var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.835 7.012a1.378 1.378 0 00-1.915-.045 1.301 1.301 0 00-.046 1.87l8.11 8.184a1.424 1.424 0 001.979-.043l8.062-8.141a1.3 1.3 0 00-.044-1.87 1.378 1.378 0 00-1.915.042l-6.798 6.748a.45.45 0 01-.634 0L4.835 7.012z"
  })));
}
export default SvgChevronDown;